import React from 'react';
import { IconProps } from '../types';
const MinecraftSeaPickle: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="2" width="1" height="1" fill="rgba(216, 255, 214, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(197, 244, 194, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(216, 255, 214, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(180, 227, 177, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(197, 244, 194, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(180, 227, 177, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(197, 244, 194, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(98, 104, 36, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(98, 104, 36, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(98, 104, 36, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(98, 104, 36, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(108, 114, 42, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(46, 48, 18, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(46, 48, 18, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(87, 92, 29, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(75, 79, 25, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(66, 70, 24, 255)" />
</svg>);
export default MinecraftSeaPickle;